import { useMutation } from '@apollo/client'
import { AddPretestSurveyResponses, AddPretestSurveyResponsesVariables } from '../../types'
import { ADD_PRETEST_SURVEY_RESPONSES } from './operations'

export const useAddPreTestSurveyResponses = () =>
  useMutation<AddPretestSurveyResponses, AddPretestSurveyResponsesVariables>(
    ADD_PRETEST_SURVEY_RESPONSES
  )
